import * as actionType from "../constants/action_types";
const initialState = {
  list: null,
  details: null,
  update_response: "",
};

const coworkerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GETCOWORKERS_RESPONSE:
      return { ...state, list: action.payload };
    case actionType.GETCOWORKER_RESPONSE:
      return { ...state, details: action.payload };
    case actionType.GETCOWORKERCOMPANIES_RESPONSE:
      return {
        ...state,
        details: { ...state.details, coworker_companies: action.payload },
      };
    case actionType.TOGGLECOWORKER_RESPONSE:
      return { ...state, update_response: action };
    case actionType.DELETECOWORKER_RESPONSE:
      return { ...state, update_response: action };
    case actionType.RESETCOWORKERPWD_RESPONSE:
      return { ...state, update_response: action };
    case actionType.CREATECOWORKER_RESPONSE:
      return { ...state, update_response: action };
    case actionType.EDITCOWORKER_RESPONSE:
      return { ...state, update_response: action };
    case actionType.COWORKERCOMPANY_RESPONSE:
      return { ...state, update_response: action };
    case actionType.RESET2FA_RESPONSE:
      return { ...state, update_response: action };
    default:
      return state;
  }
};

export { coworkerReducer };
